
<template>
  <v-container fill-height fluid grid-list-xl>
    <Loader :loading="loading" />
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card color="green" title="Список" text="Все группы">
          <v-btn color="success" @click="dialog = true" class="mr-2" text>Добавить группу</v-btn>
          <v-btn color="primary" @click="getItems(false)" text>Обновить</v-btn>
          <v-data-table :headers="headers" :items="PagesList" hide-actions>
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td class="text-xs-left"><b>{{item.id}}</b></td>
              <td class="text-xs-left">{{item.title}}</td>
              <td class="text-xs-left">
                <span v-if="item.ID_1C">{{item.ID_1C}}</span>
                <span v-else>Не установлено</span>
              </td>
              <td class="text-xs-right min-width100">
                <v-icon @click="open(item)">mdi-pencil</v-icon>
              </td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>

    <v-dialog persistent fullscreen transition="dialog-bottom-transition" v-model="dialogShow">
      <v-card>
        <Loader :loading="loading" absolute="true" />
        <v-btn class="close default v-btn--simple" @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-text>
          <div class="body-2 mt-5">ID 1C</div>
          <v-text-field v-model="dataItem.ID_1C" label="Ввидете ID"></v-text-field>
          <br />
         
          <div class="body-2 mb-2">Имя</div>
          <v-text-field v-model="dataItem.title" label="Ввидите название группаы" hide-details></v-text-field>
          <br />
      
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="text-xs-center">
          <v-btn color="success" text @click="addItem">
            <span v-if="dataItem.id">Сохранить</span>
            <span v-else>Добавить аккаунт</span>
          </v-btn>
          <v-btn color="primary" text @click="closeDialog">Отмена</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Loader from "../../helper/Loader";

import { mapMutations } from "vuex";
import Page from "../Pages/Page";

export default {
  data: () => ({
    Page_title: "",
    PageAddModal: false,
    page: 1,
    searcher: null,
    loadingSearch: true,
    loading: true,
    last_page: 0,
    search: "",
    headers: [
      {
        sortable: false,
        text: "ID",
        value: "dealer.title"
      },
      {
        sortable: false,
        text: "Название",
        value: "dealer.title"
      },
      {
        sortable: false,
        text: "ID 1C",
        value: "dealer.title"
      },
      {
        sortable: false,
        text: "",
        value: "dealer.phone_number"
      }
    ],
    PagesList: [],
    pageID: null,
    total: 0,
    dialog: false,
    dataItem: {
      id: null,
      is_active: 1,
      phone: null,
      group_id: null,
      name: null,
      name_company: null,
      address: null,
      group: null
    },
    group: []
  }),
  components: { Page, Loader },
  methods: {
    ...mapMutations(["SET_USER", "SET_BADGE_ORDERS"]),
    setOrders(val) {
      if (val) {
        this.getItems();
      }
    },
    getItems(noLoading) {
      if (!noLoading) this.loading = true;

      axios
        .get("admin/distributors/group/list")
        .then(response => {
          this.PagesList = response.data;
        })
        .catch(error => {})
        .finally(() => {
          this.loadingSearch = false;
          this.loading = false;
        });
    },

    getGroups() {
      axios.get("admin/distributors/group/list").then(response => {
        this.group = response.data;
      });
    },
    open(data) {
      this.dataItem = data;
    },
    closeDialog() {
      this.dialog = false;
      this.dataItem = {
        id: null,
        is_active: 1,
        phone: null,
        group_id: null,
        name: null,
        name_company: null,
        address: null,
        group: null
      };
    },

    addItem() {
      this.loading = true;
      axios
        .post("admin/distributors/group/set", this.dataItem)
        .then(response => {
          this.$toast.success({
            title: this.vendor_code,
            message: "Аккаунт успешно добавлен"
          });
          this.dataItem = response.data;
          this.getItems();
          setTimeout(() => {
            // this.getItems();
          }, 300);
        })
        .catch(error => {
          let data = error.response.data;
          if (data.errors) {
            let k = 0;
            Object.keys(data.errors).forEach(item => {
              let err = data.errors[item];
              k++;
              for (let i = 0; i < err.length; i++) {
                setTimeout(() => {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i]
                  });
                }, 100 * k);
              }
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    notify() {
      this.loading = true;
      axios
        .put("admin/distributors/notify", this.dataItem)
        .then(response => {
          this.$toast.success({
            title: this.vendor_code,
            message: "Пароль успешно отправлен на номер"
          });
          this.dataItem = response.data;
          setTimeout(() => {
            this.getItems();
          }, 300);
        })
        .catch(error => {
          let data = error.response.data;
          if (data.errors) {
            let k = 0;
            Object.keys(data.errors).forEach(item => {
              let err = data.errors[item];
              k++;
              for (let i = 0; i < err.length; i++) {
                setTimeout(() => {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i]
                  });
                }, 100 * k);
              }
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  watch: {
    search() {
      this.loadingSearch = true;
      clearTimeout(this.searcher);
      this.searcher = setTimeout(() => {
        this.page = 1;
        this.getItems(true);
      }, 1500);
    },
    page() {
      setTimeout(() => {
        this.getItems();
      }, 300);
    }
  },
  mounted() {
    this.getGroups();
    this.getItems();
  },
  computed: {
    dialogShow: {
      get() {
        return this.dialog || this.dataItem.id ? true : false;
      }
    }
  }
};
</script>